import React from 'react';

import BackupAgingChart from '@totem/components/services/backup/deviceBackups/backupSummary/backupAgingChart';
import BackupSummaryContainer from '@totem/components/services/backup/deviceBackups/backupSummary/backupSummaryContainer';

const WidgetBackupAging = () => {
  return (
    <BackupSummaryContainer>
      <BackupAgingChart />
    </BackupSummaryContainer>
  );
};

export default WidgetBackupAging;
